module.exports = __webpack_public_path__ + "img/img17.a12225f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img17.png
// module id = 172
// module chunks = 0